export default {
  ANONYMOUS: 'ANONYMOUS',
  LOGGED_IN: 'LOGGED_IN',
  AWAITING_RESPONSE: 'AWAITING_RESPONSE'
};



// WEBPACK FOOTER //
// ./src/constants/auth-status.js